export default function navItem({ ank, label }) {
    return $(`
        <a class="nav-link" href="#${ank}">${label}</a>
    `);
}